import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

import './styles/defaultreferral.css';

export default function defaultReferral() {
  return (
    <>
      <div className="default_referral m-3">
        <Container>
            <div className="default_ref">
                <div className="default_ref_head d-flex justify-content-between">
                    <div className="default_head_para">
                        <p>Default Referral</p>
                    </div>
                    <div className="default_head_span">
                        <span><a href="http://" target="_blank">Spot - Invite Link Configuration</a></span>
                    </div>
                </div>
            <Row>
                <Col>
                  <Row className='default_ref_main_row'>
                    <Col lg={7}>
                      <div className='left_side d-flex justify-content-between'>
                        <div className="left_left_side d-flex flex-column gap-4">
                        <div className='d-flex justify-content-start left_left_head'>
                          <span>Spot Trading</span>
                        </div>
                        <div className='d-flex gap-5 left_left_content'>
                          <div>
                            <h3>15%</h3>
                            <span>You Receive</span>
                          </div>
                          <div>
                            <h3>15%</h3>
                            <span>Friend Receive</span>
                          </div>
                        </div>
                        </div>
                        <hr />
                        <div className="left_right_side d-flex flex-column gap-4">
                        <div className='d-flex justify-content-start left_right_head'>
                          <span>Futures Trading</span>
                        </div>
                        <div className='d-flex gap-5 left_right_content'>
                          <div>
                            <h3>10%</h3>
                            <span>You Receive</span>
                          </div>
                          <div>
                            <h3>10%</h3>
                            <span>Friend Receive</span>
                          </div>
                        </div>
                        </div>
                      </div>
                    </Col>
                    <Col lg={5}>
                      <div className="right_side">
                        <div className="right_content mb-3">
                          <div className="right_content1 d-flex justify-content-between">
                            <span>Referral ID</span>
                            <span>AXE6N6GHM</span>
                          </div>
                          <div className="right_content2 d-flex justify-content-between">
                            <span>Referral Link</span>
                            <span>https://app.supe...AXE6N6GHM</span>
                          </div>
                        </div>
                        <div className="right_side_btn">
                          <Button>Invitation Poster</Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
            </Row>
            </div>
        </Container>
      </div>
    </>
  )
}
